module.exports = __webpack_public_path__ + "static/media/mainCharForError2.6d7f3c2f.png";